import { yup } from 'common/validation/initYup';

// Login
export const employeeCreateAccessTokenValidator = yup
  .object({
    username: yup.string().required().label('Username'),
    password: yup.string().label('Password').required()
  })
  .noUnknown()
  .required();

export type IEmployeeCreateAccessTokenDto = yup.InferType<
  typeof employeeCreateAccessTokenValidator
>;
